/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, hour: NonNullable<unknown> }} Special_Event_Timer_Count_DownInputs */

const en_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts in ${i?.day}d ${i?.hour}h`)
};

const ar_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدأ خلال ${i?.day} يوم و${i?.hour} ساعة`)
};

const de_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beginnt in ${i?.day} T. ${i?.hour} Std.`)
};

const es_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza en ${i?.day} d ${i?.hour} h`)
};

const fr_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commence dans ${i?.day} j ${i?.hour} h`)
};

const it_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia tra ${i?.day} g ${i?.hour} h`)
};

const ja_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開始まであと${i?.day}日${i?.hour}時間`)
};

const ko_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`시작까지 ${i?.day}일 ${i?.hour}시간`)
};

const pt_br_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa em ${i?.day}d ${i?.hour}h`)
};

const ru_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начнется через ${i?.day} д. ${i?.hour} ч.`)
};

const th_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มในอีก ${i?.day} วัน ${i?.hour} ชม.`)
};

const tr_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} gün ${i?.hour} saat içinde başlıyor`)
};

const zh_cn_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`距离开始还有 ${i?.day} 天 ${i?.hour} 小时`)
};

const zh_tw_special_event_timer_count_down = /** @type {(inputs: Special_Event_Timer_Count_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} 天 ${i?.hour} 小時後開始`)
};

/**
* | output |
* | --- |
* | "Starts in {day}d {hour}h" |
*
* @param {Special_Event_Timer_Count_DownInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const special_event_timer_count_down = /** @type {((inputs: Special_Event_Timer_Count_DownInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Special_Event_Timer_Count_DownInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_special_event_timer_count_down(inputs)
	if (locale === "ar") return ar_special_event_timer_count_down(inputs)
	if (locale === "de") return de_special_event_timer_count_down(inputs)
	if (locale === "es") return es_special_event_timer_count_down(inputs)
	if (locale === "fr") return fr_special_event_timer_count_down(inputs)
	if (locale === "it") return it_special_event_timer_count_down(inputs)
	if (locale === "ja") return ja_special_event_timer_count_down(inputs)
	if (locale === "ko") return ko_special_event_timer_count_down(inputs)
	if (locale === "pt_br") return pt_br_special_event_timer_count_down(inputs)
	if (locale === "ru") return ru_special_event_timer_count_down(inputs)
	if (locale === "th") return th_special_event_timer_count_down(inputs)
	if (locale === "tr") return tr_special_event_timer_count_down(inputs)
	if (locale === "zh_cn") return zh_cn_special_event_timer_count_down(inputs)
	return zh_tw_special_event_timer_count_down(inputs)
});